import React, { useMemo } from 'react';
import InFieldPlayer from './InFieldPlayer';
import {
  CardEvent,
  CardTypeEnum,
  ChangeEvent,
  GoalEvent,
  Lineup,
  PlayerListElement,
  TeamListElement,
} from '../../../../client/api';
import { useStableId } from '../../../../hooks/useStableId';

type PlayersInFieldProps = {
  rotated: boolean;
  lineup: Lineup;
  cardEvents: CardEvent[];
  changeEvents: ChangeEvent[];
  goalEvents: (Omit<GoalEvent, 'player'> & { player: PlayerListElement })[];
  team: TeamListElement;
  playerRatings?: Record<string, (number | null)>;
};

const PlayersInFieldBase: React.FC<PlayersInFieldProps> = ({
  lineup,
  rotated,
  cardEvents,
  goalEvents,
  changeEvents,
  team,
  playerRatings,
}) => {
  const finalPlayers = useMemo(
    () =>
      lineup.players.map((player) => ({
        position: player.position,
        player: player.player,
        goal: goalEvents.filter((event) => event.player.id === player.player.id)
          .length,
        card: cardEvents
          .filter((event) => event.player?.id === player.player.id)
          .reduce<CardEvent | undefined>((prevCard, currentCard) => {
            if (prevCard === undefined) return currentCard;
            if (
              prevCard.cardType.key === CardTypeEnum.YELLOW &&
              (currentCard.cardType.key === CardTypeEnum.RED ||
                currentCard.cardType.key === CardTypeEnum.YELLOW_RED)
            )
              return currentCard;
            return prevCard;
          }, undefined),
        change:
          changeEvents.filter((event) => event.player.id === player.player.id)
            .length !== 0,
        team,
        rating: playerRatings?.[player.player.id.toString()] ?? null,
      })),
    [cardEvents, team, changeEvents, goalEvents, lineup.players, playerRatings],
  );

  const key = useStableId('pif');
  return (
    <>
      {finalPlayers.map((p) => (
        <InFieldPlayer
          p={p}
          rotated={rotated}
          key={`${p.position.id}pl${key}`}
        />
      ))}
    </>
  );
};

export default PlayersInFieldBase;
